import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { filter, map, mergeMap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

const APP_TITLE = 'ipex |';
const SEPARATOR = ' > ';

@Injectable()
export class TitleService {
    private _replacerList = new Map<string, string>();
    isProfileUpdate = new BehaviorSubject<boolean>(false);


    constructor(
        private translateService: TranslateService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title
    ) {}

    static ucFirst(string) {
        return string ? string.charAt(0).toUpperCase() + string.slice(1) : string;
    }

    init() {
        const getTitle = (acc, frag) => {
            if (acc && frag) {
                acc += SEPARATOR;
            }
            return acc + (this._replacerList.has(frag) ? this._replacerList.get(frag) : TitleService.ucFirst(frag));
        };
        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                map(() => {
                    let route = this.activatedRoute;
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                }),
                filter(route => route.outlet === 'primary'),
                mergeMap(route => route.data),
                map(data => {
                    return data['breadcrumb'] ? data['breadcrumb'] : this.router.url.split('/').reduce(getTitle);
                })
            )
            .subscribe(pathString => {
                this.translateService.stream(pathString).subscribe(response => {
                    this.titleService.setTitle(`${APP_TITLE} ${response}`);
                });
            });
    }

    forceSetTitle() {
        let title = this.titleService.getTitle();
        this._replacerList.forEach((value, key) => {
            if (title.includes(key)) {
                title = title.replace(key, value);
            } else if (title.includes(TitleService.ucFirst(key))) {
                title = title.replace(TitleService.ucFirst(key), value);
            }
        });
        this.titleService.setTitle(title);
    }

    addReplacer(key: string, value: string) {
        this._replacerList.set(key, value);
        this.forceSetTitle();
    }

    removeReplacer(key: string) {
        if (this._replacerList.has(key)) {
            this._replacerList.delete(key);
        }
    }
     
}
